<script lang="ts">
	let name:string = 'world';

	import {getContext, onMount} from 'svelte';
	import {type Player, type Match, type Meeting, type AuthorizedResult, unauthorizedAccess, authorized, type PlayerStatistic} from './src/types';    
	import MeetingRow from './PlayerMeetingRow.svelte';
	import {getMatches,getMeetings,getPlayerRanking, getPlayer} from './src/client'
	import { push } from 'svelte-spa-router'

	export let team: string;

	export let season: string;

	export let guest: boolean | null | undefined = false

	let players : Player[] = [];

	export let params;

	let meetingsFilter : string = '';

	let statistics: PlayerStatistic[] = [];

	const setAuthenticated = getContext<(b:boolean) => void>('setAuthenticated');

	onMount(async () => {
		team = (team === undefined ||team === null)  ? params.team : team;
        season = (season === undefined || season === null) ? params.season : season;
        guest = (guest === undefined || guest === null) ? false : guest;
		let p = await getPlayers(season,team);
		if (p.authorized) {
			players = p.result as Player[];
		}
		else {
			setAuthenticated(false);
			push('/login');
			return;
		}
		let s = await getStatistics(season,team);
		if (s.authorized) {
			statistics = s.result as PlayerStatistic[];
		}
		else {
			setAuthenticated(false);
			push('/login');
			return;
		}
	});


	let player:Player|undefined = undefined;
	let playerName:string = "";	
	let playerRanking:number = 500;
	let playerMeetings:Meeting[];
	let playerMatches:Match[]|undefined = [];
	let playerVictories:number = 0;
	let playerDefeats:number = 0;

	let getPlayerData = async() => {
		player=undefined;
		playerRanking = 500;
		playerMatches = undefined;
		playerVictories = 0;
		playerDefeats = 0;
		const p = await getPlayer(season,team,playerName,meetingsFilter);
		if (p.authorized) {
			player = p.result;
		}
		else {
			setAuthenticated(false);
			push('/login');
			return;
		}
		if (!player) {
			return;
		}
		const r = await getPlayerRanking(season,team,playerName);
		if (r && r.authorized) {
			playerRanking = r.result as number;
		}
		else {
			setAuthenticated(false);
			push('/login');
			return;
		}
		winning = playerRanking >= player.ranking;
		won = playerRanking - player.ranking;
		const m = await getMatches(season,team,playerName,meetingsFilter);
		if (m && m.authorized) {
			playerMatches = m.result;
		}
		else {
			setAuthenticated(false);
			push('/login');
			return;
		}
		if (playerMatches && playerMatches.length > 0) {
			playerVictories = playerMatches.filter(x => x.score.me > x.score.other).length;
			playerDefeats = playerMatches.length - playerVictories;
		}
		playerMeetings = getMeetings(playerMatches as Match[]);
	}

	let getStatistics = async (season: string, teamName: string): Promise<AuthorizedResult<PlayerStatistic[]>> => {
		let r = await fetch(`/statistics/${season}/${teamName}`, {method:"GET"});
		console.log(r);
		if (r.status == 401) {
			return unauthorizedAccess();
		}
		if (r.status != 200) {
			console.log('zut');
			console.log(`une erreur est survenue ${r.status}:${r.statusText}`);
		}
		const stats:PlayerStatistic[] = await r.json();
		return authorized(stats);
	}

	let getPlayers = async (season: string, teamName: string):Promise<AuthorizedResult<Player[]>> => {
		let r = await fetch(`/players/${season}/${teamName}`,
		{
			method:"GET"
		});
		console.log(r);
		if (r.status == 401) {
			return unauthorizedAccess();
		}
		if (r.status != 200) {
			console.log('zut');
			console.log(`une erreur est survenue ${r.status}:${r.statusText}`);
		}
		const players:Player[] = await r.json();
		return authorized(players)		
	}

	let playerVisibility:boolean = false;

	export let displaySheet : (id: number) => void  = (id:number) => {
        push(`/sheet/${id}`);
    };

	let won : number = 0;
	let winning : boolean = true;

	$: {
		console.log(`reactive filter :: >${meetingsFilter}<`)	
		getPlayerData().then((e) => {console.log(e)})
	}

 
</script>
<style>
	.center {
		margin-left: auto;
		margin-right: auto;
		width:fit-content;
	}

</style>

<div style="display:flex;flex-direction: row;">

{#if players && players.length > 0}

<div style="flex-grow:1; display:flex; flex-direction:column">
	{#each statistics as statistic}
	<!-- svelte-ignore a11y-click-events-have-key-events -->
	<!-- svelte-ignore a11y-no-static-element-interactions -->
	<div on:click={async () => {playerName=statistic.player.name; playerVisibility=true; await getPlayerData();}}>
	<!-- svelte-ignore a11y-click-events-have-key-events -->
	<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
	<h3 style="text-align:center" on:click={async () => {playerVisibility=true; await getPlayerData();}}>
		{statistic.player?.name} : {statistic.virtualRanking} ({statistic.player?.ranking}, {statistic.win+statistic.loss} matchs) 
		
		<span style="color:{statistic.wonPoints >= 0 ? 'green': 'red'} ">{statistic.wonPoints >= 0 ?  "↗️" : "↘️"} {statistic.wonPoints}</span>
	</h3>

	<div class="center" on:click={async () => {playerVisibility=true; await getPlayerData();}}>
	<table>
		<tr><td>Victoires</td><td>{statistic.win}</td></tr>
		<tr><td>Défaites</td><td>{statistic.loss}</td></tr>
	</table>
	</div>
	</div>
	{/each}	

</div>
{/if}


<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
<div style="display:{playerVisibility ? 'block' : 'none'};flex-grow:5">
	<!-- <input type="text" bind:value={playerName} on:keydown={search}/>  -->
	<!-- <input type="button" value="get" on:click={getPlayerData}/> -->
		<h3 style="text-align:center">{player?.name}</h3>
			<input type="text" placeholder="filtrer les matchs" bind:value={meetingsFilter} />
			{#if  playerMeetings && playerMeetings.length > 0} 
			<div style="display:flex; flex-flow: row wrap">
				{#each playerMeetings as meeting (meeting.sheetId)}
					<MeetingRow guest={guest} {meeting} displaySheet={displaySheet}/> 
				{/each}
			</div>
			{/if}

</div>
</div>